import React, { useEffect, useRef, useState } from "react";
import "../../css/TextMessageModal.css";

export default function TextMessageModal({
    isOpen,
    title = "Enter message",
    initialValue = "",
    onSave,
    onClose,
    placeholder = "Type your message...",
    rows = 3,
    maxLength = 120,
    hint = "Enter to save. Shift or Ctrl + Enter for new line."
}) {
    const [value, setValue] = useState(initialValue || "");
    const inputRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            setValue(initialValue || "");
            setTimeout(() => {
                const node = inputRef.current;
                if (!node) return;
                node.focus?.();
                const length = node.value?.length || 0;
                try {
                    node.setSelectionRange(length, length);
                } catch (err) {
                    // Some browsers may not support selection on focus; ignore.
                }
            }, 0);
        }
    }, [isOpen, initialValue]);

    if (!isOpen) return null;

    const handleSave = () => {
        const trimmed = (value || "").trim();
        onSave?.(trimmed);
    };

    const handleKeyDown = (event) => {
        if (event.key !== "Enter") return;
        if (event.shiftKey || event.ctrlKey || event.metaKey) {
            return;
        }
        event.preventDefault();
        handleSave();
    };

    return (
        <div className="text-message-modal-overlay" onClick={onClose}>
            <div className="text-message-modal" onClick={(e) => e.stopPropagation()}>
                <h3>{title}</h3>
                <textarea
                    ref={inputRef}
                    className="text-message-input"
                    rows={rows}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder={placeholder}
                    maxLength={maxLength}
                />
                <div className="text-message-hint">{hint}</div>
                <div className="text-message-buttons">
                    <button type="button" onClick={handleSave}>Save</button>
                    <button type="button" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
}
